import { render, staticRenderFns } from "./IncomingCards.vue?vue&type=template&id=504a921a&"
import script from "./IncomingCards.vue?vue&type=script&lang=js&"
export * from "./IncomingCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports